import { useEffect, useRef } from "react";
import { NotiIcon } from "./imgs/NotiIcon";
import { CloseIcon } from "./imgs/Close";
import { useNotifyContext } from "./hooks";
import CardsContainer from "./CardsContainer";
import ScrollCard from "./ScrollCard";
import cs from './index.module.scss';
import NoData from './nodata';

const getMoreInContainer = (ele, dis = 400) => {
  const offsetHeight = ele.offsetHeight;
  const scrollHeight = ele.scrollHeight;
  const scrollTop = ele.scrollTop;

  return scrollHeight - (offsetHeight + scrollTop) < dis;
}

export const ManulNoti = () => {
  const scrollRef = useRef(null);
  const { t, querys, context, setContext, noticeList, setQuerys  } = useNotifyContext();

  const onAllNoticeClick = () => {
    setContext({
      manulNotiOpen: !context.manulNotiOpen,
    });
  };

  const closeAllNoticeClick = () => {
    setContext({
      manulNotiOpen: false,
    });
  };

  const loadMore = () => {
    if (scrollRef.current && getMoreInContainer(scrollRef.current) && context.hasNext && !context.isFetchList) {
      setQuerys({
        pageIndex: querys.pageIndex + 1,
      });
    }
  }

  useEffect(() => {
    if (!context.manulNotiOpen) {
      return;
    }
    loadMore();
  }, [noticeList.length, context.hasNext, context.manulNotiOpen]);

  const onContainerScroll = () => {
    loadMore();
  };

  return (
    <>
      <span
        className={cs.allNoticeBtn}
        onClick={onAllNoticeClick}
      >
        <NotiIcon style={{ position: 'relative', top: 2, marginRight: 5, }} />
        <span>{t('notify.notification')}</span>
      </span>
      
      {context.manulNotiOpen ?
        <CardsContainer ref={scrollRef} onScroll={onContainerScroll} className={cs.scrollCardsContainer}>
          <div className={cs.scrollHeader}>
              <span className={cs.scrollTitle}>{t('notify.notification')}</span>
              <CloseIcon className={cs.closeIcon} onClick={closeAllNoticeClick} />
          </div>
          {noticeList?.length ? noticeList.map(item => <ScrollCard key={item.id} config={item} />) : <NoData />}
        </CardsContainer> :
        null
      }
    </>
  );
};
